export const environment = {
	production: false,
	API_URL: "https://shore-care.3cubehealth.com/",
	MFA_API_URL: "https://2h2ozsrc9i.execute-api.ap-south-1.amazonaws.com/dev/",
	File_Storage_URL: "https://backend-content-storage.s3.ap-south-1.amazonaws.com/",
	firebaseConfig: {
		apiKey: "AIzaSyBoOkfzCMlvkXKUU5vr0Nm1czhlWe7S7_I",
		vapiKey: "BFgS6x5cTiSS-KmuviFdoy0CHuv57kbjo0Yj9G2XPfCRhxqyP59NRr4yQfUVwXLLMPSwbpgGbTb_geYX-USc8DA",
		authDomain: "shorecare-staging.firebaseapp.com",
		projectId: "shorecare-staging",
		storageBucket: "shorecare-staging.firebasestorage.app",
		messagingSenderId: "321351134243",
		appId: "1:321351134243:web:9dedf77714ceac4d8dd596",
		measurementId: "G-0WHLP2TF74"
	},
	fire_u: "yogesh.kapase@technicious.in",
	fire_p: "Tech@123",
	email_id: "sc@emails.3cubehealth.com",
	agoraAppID: '731e0cc2e2a04d1ab31cc97de766a6b1',
	/* agoraAppKey: '61325812#1622633', */
	/* agoraChatRoomOwner: "doc_14" */
	teleconsultCatId: 8
};